<template>
  <div class="office-map">
    <iframe
      :src="frame_src"
      width="100%"
      height="450"
      title="Company map location"
      allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
  </div>
</template>

<script>
import {axiosCustomerQuestion} from "../../../admin/helpers/axios_requests";
import {NEW_CUSTOMER_QUESTION} from "../../helpers/new_objects";
import DefaultInput from "../small_parts/DefaultInput.vue";
import DefaultButton from "../slots/DefaultButton.vue";
import FormSubmittingPopup from "../modals/FormSubmittingPopup.vue";
import DefaultTextarea from "../small_parts/DefaultTextarea.vue";
import TermsCheckbox from "../small_parts/TermsCheckbox.vue";

export default {
  name: "OfficeMap",
  props: {
    frame_src: {
      type: String,
      required: true
    }
  }
}
</script>
